import { format, parseISO, startOfDay } from 'date-fns'

export const removeNullProperties = obj => {
  if (Array.isArray(obj)) {
    return obj
      .map(removeNullProperties)
      .filter(
        item =>
          item !== null &&
          item !== undefined &&
          (typeof item !== 'string' || item.trim() !== '')
      )
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleanedValue = removeNullProperties(value)
      if (
        cleanedValue !== null &&
        cleanedValue !== undefined &&
        (typeof cleanedValue !== 'string' || cleanedValue.trim() !== '')
      ) {
        acc[key] = cleanedValue
      }

      return acc
    }, {})
  }

  return obj
}

export const formatDateForSubmit = dateInput => {
  if (!dateInput) return ''

  try {
    let date
    if (dateInput instanceof Date) {
      date = dateInput
    } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
      return dateInput
    } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateInput)) {
      const [month, day, year] = dateInput.split('/')
      date = new Date(year, month - 1, day)
    } else {
      date = parseISO(dateInput)
    }

    if (isNaN(date.getTime())) {
      console.warn('Invalid date:', dateInput)
      return ''
    }

    return format(startOfDay(date), 'yyyy-MM-dd')
  } catch (error) {
    console.warn('Error formatting date:', dateInput, error)
    return ''
  }
}

export const mapPatientProfileToFormValues = patient => {
  if (!patient) return {}

  return {
    firstName: patient.firstName || '',
    lastName: patient.lastName || '',
    gender: patient.gender || '',
    dateOfBirth: patient.dob || '',
    email: patient.email || '',
  }
}

export const mapInsuranceFormPatientToFormValues = ifPatient => {
  if (!ifPatient) return {}

  return {
    patientId: ifPatient.id || null,
    firstName: ifPatient.firstName || '',
    lastName: ifPatient.lastName || '',
    gender: ifPatient.gender || '',
    dateOfBirth: ifPatient.dob || '',
    phone: ifPatient.phone || '',
    email: ifPatient.email || '',
    employerName: ifPatient.employerName || '',
    memberId: ifPatient.memberId || '',
    planNumber: ifPatient.planGroupNumber || '',
    payerId: ifPatient.insurancePayer?.id || ifPatient.insurancePayerId || '',
    payerCode: ifPatient.insurancePayer?.code || '',
    insuranceCompany:
      ifPatient.insurancePayer?.name || ifPatient.insuranceCompany || '',
    insuranceCoverageStartDate: ifPatient.insuranceCoverageStart || '',
    insurance_card_front: ifPatient.insuranceCardFrontUrl,
    insurance_card_back: ifPatient.insuranceCardBackUrl,
    insuranceCardFrontUrl: ifPatient.insuranceCardFrontUrl,
    insuranceCardBackUrl: ifPatient.insuranceCardBackUrl,
    staff_consult_policy_holder_subscriber_id:
      ifPatient.staffConsultPolicyHolderSubscriberId,
  }
}

export const mapInsuranceFormSubscriberToFormValues = subscriber => {
  if (!subscriber) return {}

  return {
    subscriberId: subscriber.id || null,
    policyHolderFirstName: subscriber.firstName || '',
    policyHolderLastName: subscriber.lastName || '',
    policyHolderGender: subscriber.gender || '',
    policyHolderDateOfBirth: subscriber.dob || '',
    policyHolderEmployerName: subscriber.employerName || '',
    relationToPatient: subscriber.relationToPatient || '',
    policyHolderSubscriberId: subscriber.policyHolderSubscriberId || '',
    policyHolderMemberId: subscriber.memberId || '',
  }
}

export const buildInitialFormValues = ({ patient, insuranceForm }) => {
  const patientDefaults = mapPatientProfileToFormValues(patient)
  const ifPatientFields = mapInsuranceFormPatientToFormValues(
    insuranceForm?.patient
  )
  const subscriberFields = mapInsuranceFormSubscriberToFormValues(
    insuranceForm?.subscriber
  )

  return {
    ...patientDefaults,
    ...ifPatientFields,
    ...subscriberFields,
    id: insuranceForm?.id,
    status: 'processed',
  }
}

export const extractInsuranceFields = insuranceObj => {
  if (!insuranceObj) return {}

  return {
    id: insuranceObj.id,
    ...mapInsuranceFormPatientToFormValues(insuranceObj.patient),
    ...mapInsuranceFormSubscriberToFormValues(insuranceObj.subscriber),
  }
}
